import React, { Component } from "react";
import "./styles.css";
import G from "../../../js/globals";
import E from "../../../js/events";
import A from "axios";      // Axios     - https://github.com/axios/axios
import F from "flatpickr";  // Flatpickr - https://chmln.github.io/flatpickr/
import M from "moment";     // Moment    - https://momentjs.com/
import Loader       from "../../prefabs/loader/view";
import TimeslotItem from "./timeslot-item";

class SectionDatetime extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleClickTime      = this.handleClickTime.bind(this);
    this.getAvailableTimes    = this.getAvailableTimes.bind(this);

    this.checkLocationChanged     = this.checkLocationChanged.bind(this);
    this.checkNumAttendingChanged = this.checkNumAttendingChanged.bind(this);

    this.state = {
      loading:      false,  // Whether an API call is in progress
      calenderYear: null,   // Current calender year (shown when different from the current year)
    }

    this.cachedAttending = null;  // Internal number attending  (used to trigger re-GETs of timeslots)
    this.cachedLocation  = null;  // Internal selected location (used to trigger re-GETs of timeslots)

    this.availableCount  = 0;     // Amount of current API calls
    this.availableTimes  = [];    // Available timeslots array
  }



  // ===============================================================================================
  isSelectedTimeslot(cached, current) {
    // console.log("DATETIME:\n checking cached and current timeslots: ",
    //   "\n cached:", cached, "\n current:", current
    // );

    if (!cached || !current) { return false; }

    // In edit mode we don't care about availability
    if (this.props.editState) {
      // console.log("DATETIME:\n edit mode",
      //   "\n cached time:  ", cached.time,
      //   "\n checking time:", current.time,
      //   "\n matched?", (cached && cached.time === current.time)
      // );
      if (cached && cached.time === current.time) {
        current.available = true;
        return true;
      }
      return false;
    }
    else {
      // console.log("DATETIME:\n normal mode",
      //   "\n cached time:  ", cached.time,
      //   "\n checking time:", current.time,
      //   "\n available?", current.available,
      //   "\n matched?  ", (cached && cached.time === current.time && current.available)
      // );
      return (cached && cached.time === current.time && current.available) ? true : false;
    }
  }



  // ===============================================================================================
  getAvailableTimes(newDate) {
    // console.log("DATETIME:\n Calling getAvailableTimes()", this.props.numAttending, this.props.selLocation, newDate.format());

    if (this.props.numAttending > 0 && this.props.selLocation && this.props.selLocation.id && newDate) {
      // console.log("DATETIME:\n Attempting to get timeslots for: ", newDate.format());

      this.availableTimes = [];
      this.availableCount++;
      this.currentQueryDate = newDate.format("YYYY-MM-DD");
      this.props.handleAppEvent(E.events.DATETIME_MOD_TIME, null);
      this.setState({ loading: true });

      // Call API to get a list of time slots
      A.get(G.data.getTimeslots({
        people: this.props.numAttending,
        location: this.props.selLocation.id,
        date: this.currentQueryDate
      }), G.data.getLogin())
      .then((response) => {
        // console.log("DATETIME:\n api/restaurants", response);
        this.availableCount--;

        // We only need to do stuff on the last API call

        if (this.currentQueryDate === response.data.date) {
          let foundSelectedTime = false;
          // console.log("DATETIME:\n Selected time: ", this.props.selTime);

          if (response.data.periods && response.data.periods.length) {
            this.availableTimes = (response.data.periods).slice();

            // Parse times into a readable format
            this.availableTimes.forEach((item, index) => {
              // Check if this is the selected time
              // console.log("DATETIME:\n   new time: ", item);
              if (this.isSelectedTimeslot(this.cachedTime, item)) {
                if (this.props.app_editState) { item.available = true; }
                foundSelectedTime = true;
                item.selected = true;
                this.cachedTime = item;
              }

              item.id = index;
              let times = (item.time).replace(/:00/g, "").split("-");

              let startTimes = times[0].split(":");
              let endTimes   = times[1].split(":");

              let startHr = parseInt(startTimes[0], 10);
              let endHr   = parseInt(  endTimes[0], 10);

              // Get day or night
              let startHalf = (startHr < 12) ? "am" : "pm";
              let endHalf   = (  endHr < 12) ? "am" : "pm";

              // Get 12hr hours (if it's 12 we don't have to remove 12)
              let start12 = (startHr < 13) ? startHr : startHr - 12;
              let end12   = (  endHr < 13) ?   endHr :   endHr - 12;

              // Get 24hr hours
              let start24 = startHr;
              let end24   =   endHr;

              // Add minutes (if required)
              if (startTimes[1]) {
                start12 = start12 + "." + startTimes[1];
                start24 = start24 + "." + startTimes[1];
              }

              if (endTimes[1]) {
                end12 = end12 + "." + endTimes[1];
                end24 = end24 + "." + endTimes[1];
              }

              // Add end half to 12 hour times
              start12 = start12 + startHalf;
              end12   =   end12 +   endHalf;

              // Create labels
              item.label12 = start12 + " - " + end12;
              item.label24 = start24 + " - " + end24;
              item.label = item.label12;
            });
          }
          else {
            this.availableTimes = [];
          }

          if (!foundSelectedTime) {
            // console.log("DATETIME:\n Didn't find the selected time!!!");
            this.props.handleAppEvent(E.events.DATETIME_MOD_TIME, null);
          }
          else {
            // console.log("DATETIME:\n Restoring time", this.cachedTime);
            this.props.handleAppEvent(E.events.DATETIME_MOD_TIME, this.cachedTime);
            this.cachedTime = null;
          }

          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log("DATETIME:\n api/restaurants", error);
        this.setState({ loading: false });

        // let newErrorPopup = G.popups.newPopup()
        //   .code(G.errors.ERR_GET_TIMESLOTS_FAILED)
        //   .heading("Something went wrong.")
        //   .message((
        //     <div>
        //       <p> We couldn't load timeslot details. </p>
        //       <p> Please try again later. </p>
        //     </div>
        //   ))
        //   .confirm("Okay", null);

        // this.props.handleAppPopup(newErrorPopup);
      });
    }
  }



  // ===============================================================================================
  // Check if the props location is the same as our cached location
  checkLocationChanged() {
    if (this.cachedLocation !== this.props.selLocation) {
      this.cachedLocation = this.props.selLocation;
    }
    return false;
  }



  // ===============================================================================================
  // Check if the props numAttending is the same as our cached numAttending
  checkNumAttendingChanged() {
    if (this.cachedAttending !== this.props.numAttending) {
      this.cachedAttending = this.props.numAttending;
      return true;
    }
    return false;
  }



  // ===============================================================================================
  handleClickTime(timeslotId) {
    if (this.availableTimes && this.availableTimes[timeslotId]) {
      // console.log("Clicked a time!", timeslotId, this.availableTimes[timeslotId]);
      let newTime = this.availableTimes[timeslotId];

      (this.availableTimes).forEach((item) => {
        item.selected = (item.id === timeslotId) ? true : false;
      });

      if (!this.props.selTime || this.props.selTime.id !== newTime.id) {
        this.props.handleAppEvent(E.events.DATETIME_MOD_TIME, newTime);
      }
    }
    else {
      console.log("DATETIME:\n Invalid time?", timeslotId, this.availableTimes);
    }
  }



  // ===============================================================================================
  componentDidMount() {
    // Get the current date without time
    let currentParts = (M().format("YYYY-MM-DD")).split("-");
    let currentDate = M()
      .year(  parseInt(currentParts[0], 10)     )
      .month( parseInt(currentParts[1], 10) - 1 )
      .date(  parseInt(currentParts[2], 10)     );

    // let minimumDate = M().add(2, "weeks").toISOString();
    // let initialDate = (this.props.selDate) ? (this.props.selDate).toISOString() : null;
    let minimumDate = currentDate.add(15, "days").format("YYYY-MM-DD");
    let initialDate = (this.props.selDate) ? (this.props.selDate).format("YYYY-MM-DD") : null;



    // Save a copy of the time, if one exists at start
    if (this.props.selTime) {
      this.cachedTime = this.props.selTime;
      // console.log("cachedTime", this.cachedTime)
    }



    // Setup the datepicker
    this.datepicker = F(this.input, {
      inline:   true,

      defaultDate: initialDate,  // Null if no previously selected date
      minDate:     minimumDate,  // Two weeks from today

      onChange: (selDates, dateStr, instance) => {
        let newDate = M(dateStr);
        if (newDate.isValid() && !newDate.isSame(this.props.selDate)) {
          this.props.handleAppEvent(E.events.DATETIME_MOD_DATE, newDate);
          this.getAvailableTimes(newDate);
        }
      },

      // onMonthChange: () => {},
      onYearChange: (selDates, dateStr, instance) => {
        this.setState({ calenderYear: instance.currentYear });
      },
    });



    // If we have a selected date, get its year
    if (this.props.selDate) {
      this.setState({ calenderYear: (this.props.selDate).year() });
    }

    // Otherwise, get the current year
    else {
      this.setState({ calenderYear: M().year() });
    }



    // Stop drag events bubbling up to the parent swiper!!
    const dragEventFn = (e) => { e.stopPropagation(); }
    this.carousel.addEventListener("touchstart", dragEventFn);
    this.carousel.addEventListener("touchmove",  dragEventFn);
    this.carousel.addEventListener("touchend",   dragEventFn);
  }


  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Check if the selected location or number attending has been modified
    let mods = 0;
    if (this.checkLocationChanged())     { mods++; };  // UGH
    if (this.checkNumAttendingChanged()) { mods++; };  // React sux

    if (mods > 0) {
      if (this.props.selDate) {
        // console.log("DATETIME: Location/NumAttending changed! (updating times!)");
        setTimeout(() => {
          this.getAvailableTimes(this.props.selDate);
        }, 1);
      }
      // else {
      //   console.log("DATETIME: Location/NumAttending changed! (but no date selected, can't update times)");
      // }
    }


    // ---------------------------------------------------------------------------------------------
    // By default, show instructions in the intro...
    let introMessage = (
      <div className="timepicker__message">
        <div className="small-text">
          If you'd like to book a party within the next 14 days, please contact customer service on <a href="tel:1300268710" tabIndex="-1">1300 268 710</a><br/>
        {/* <p className="margin-top-small"> <strong> Select Date & Time </strong> </p> */}
        
        </div>
      </div>
    );



    // ---------------------------------------------------------------------------------------------
    // Also, if a location hasn't been selected, we need to let the user know
    let timeMessage = (
      <div className="timepicker__message">
        <span>
          Please select a location <br/> in the previous step
        </span>
      </div>
    );



    // ---------------------------------------------------------------------------------------------
    // If a location is selected, we can do stuff!
    if (this.props.selLocation) {
      // console.log("DATETIME:\n render(): location exists");

      // If we haven't selected a date yet, prompt the user
      if (!this.props.selDate) {
        // console.log("DATETIME:\n render(): no date selected");

        timeMessage = (
          <div className="timepicker__message">
            <span>
              Select a date above. Then choose a time slot here
            </span>
          </div>
        );
      }

      // Otherwise, if a date has been chosen...
      else {
        // console.log("DATETIME:\n render(): date selected");


        // Get the date as a formatted string
        // console.log("DATETIME:\n render(): date", this.props.selDate);
        let dateStr = (this.props.selDate).format("dddd, D MMMM YYYY");
        if (M().year() === (this.props.selDate).year()) {
          dateStr   = (this.props.selDate).format("dddd, D MMMM");
        }

        // Get the time slot string (if selected)
        // console.log("DATETIME:\n render(): time", this.props.selTime);
        let timeStr = null;
        if (this.props.selTime) {
          timeStr = (this.props.selTime).label;
        }



        // Update intro message with selected date
        if (timeStr) {
          introMessage = (
            <div className="message message--datetime">
              <span className="message__date">
                
                {dateStr}
              </span>
              <span className="message__time">
                {timeStr}
              </span>
            </div>
          );
        }
        else {
          introMessage = (
            <div className="message message--datetime">
              {dateStr}
            </div>
          );
        }



        // Update timeslot message
        // If we're making an API call, show the loader
        if (this.state.loading) {
          timeMessage = (
            <Loader text={false}/>
          );
        }

        // Otherwise, we can show the results!
        else {
          timeMessage = null;

          // Notify the user if we have less than one slot
          if (this.availableTimes.length < 1) {
            timeMessage = (
              <div className="timepicker__message">
                <span>
                  No time slots are available for <br/> {dateStr}
                </span>
              </div>
            );
          }
        }
      }
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className="cont-section cont-section--offset-header cont-section--offset-footer cont-section--offset-sidebar cont-section--datetime">

        <div className="cont-wrapper">

          <div className="cont-wrapper--intro">
          
            <div className="intro">
              {introMessage}
            </div>

            <div className="weekdays">
              <span>S</span>
              <span>M</span>
              <span>T</span>
              <span>W</span>
              <span>T</span>
              <span>F</span>
              <span>S</span>
            </div>

          </div>



          <div className="cont-wrapper--datepicker">
            <div className="datepicker">

              <div className={"current-year" +
                ((this.state.calenderYear === M().year()) ? " current-year--hidden" : "")}>
                {this.state.calenderYear}
              </div>

              <input className="datepicker__input"
                tabIndex="-1"
                ref={(ele) => { this.input = ele; }}
              />

            </div>
          </div>



          <div className="cont-wrapper--timepicker">
            
            <div className="timepicker">

              {timeMessage}

              <div className={"timepicker__container" +
                ((this.loading || this.availableTimes.length < 1) ? " timepicker__container--hidden" : "")}
                ref={(ele) => { this.carousel = ele; }}>

                {this.availableTimes.map((item) => (
                  <TimeslotItem key={item.id} className="timepicker__item"
                    label={item.label}
                    selected={item.selected === true}
                    inactive={item.available !== true}
                    value={item.id}
                    handleClick={this.handleClickTime}>
                  </TimeslotItem>
                ))}
              </div>

            </div>
          </div>


              {this.props.eventType === 'no-host' && (
                <div className="cont-wrapper--end">
                  <strong>Reminder:</strong> Bookings are for 90 minutes. This includes set-up and pack-down time.  
                </div>
              )}


        </div>
      </div>
    );
  }

}



export default SectionDatetime
